import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initProgramsCards() {
  Alpine.data(
    'programsCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperPrograms = this.$el.querySelector('.swiper-programs');
        if (swiperPrograms) {
          this.initSwiper(swiperPrograms as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          direction: 'horizontal',
          autoHeight: true,
          autoplay: true,
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 'auto',
              direction: 'vertical',
              loop: false,
              autoHeight: false,
              autoplay: false,
            },
          },
        });
      },
    }),
  );
}
